export default __webpack_public_path__ + "static/media/content-deco-2.a2cf73a8.webp";